"use client";
import React, { useEffect } from "react";
import { Next13ProgressBar } from "next13-progressbar";
import { NextUIProvider } from "@nextui-org/react";
import { useRouter } from "next/navigation";
import axios from "axios";

const Providers = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();

  useEffect(() => {
    // Setup axios interceptor for blocked users
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 403) {
          // Check if error message indicates user is blocked
          const errorMessage = error.response?.data?.message || "";
          if (errorMessage.toLowerCase().includes("bloqueado") || 
              errorMessage.toLowerCase().includes("blocked")) {
            router.push("/blocked");
          }
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptor on unmount
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [router]);

  return (
    <NextUIProvider navigate={router.push} className="h-full w-full">
      {children}
      <Next13ProgressBar
        height="4px"
        color="#0A2FFF"
        options={{ showSpinner: false }}
        showOnShallow
      />
    </NextUIProvider>
  );
};

export default Providers;
